'use client';

import { useEffect, useRef } from 'react';
import { Box, useTheme } from '@mui/material';
const FORM_WRAPPER_ID = 'hubspotBlogFormWrapper';

// these come from Hubspot
const HBSPT_FORM_REGION = 'na1';
const HBSPT_PORTAL_ID = '20244782';
const HBSPT_FORM_ID = '22d5267b-92f7-44a0-81ca-73eee67a313d';
export const HubspotBlogForm = () => {
  const theme = useTheme();
  const scriptRef = useRef<HTMLScriptElement | null>(null);
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/shell.js';
    script.type = 'text/javascript';
    document.body.appendChild(script);
    scriptRef.current = script;
    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: HBSPT_FORM_REGION,
          portalId: HBSPT_PORTAL_ID,
          formId: HBSPT_FORM_ID,
          target: `#${FORM_WRAPPER_ID}`
        });
      }
    });
    return () => {
      if (scriptRef.current) {
        document.body.removeChild(scriptRef.current);
      }
    };
  }, []);
  return <Box id={FORM_WRAPPER_ID} sx={{
    maxWidth: 'sm',
    mx: 'auto',
    minHeight: {
      xs: 150,
      sm: 100
    },
    '& .hs-form': {
      display: 'flex',
      flexDirection: {
        xs: 'column',
        sm: 'row'
      },
      gap: {
        xs: 2,
        sm: 0
      }
    },
    '& .hs-form-field': {
      width: '100%'
    },
    '& .hs-input': {
      fontFamily: theme.typography.fontFamily,
      width: '100%',
      px: 2.5,
      py: 2,
      border: '1px solid',
      borderColor: 'grey.400',
      fontSize: 16,
      lineHeight: 1.3,
      '&:hover, &:focus': {
        borderColor: 'grey.600'
      }
    },
    '& .hs-submit .hs-button': {
      all: 'unset',
      boxSizing: 'border-box',
      width: {
        xs: '100%',
        sm: 'auto'
      },
      textAlign: 'center',
      px: {
        xs: 2,
        sm: 2.5
      },
      py: {
        xs: 0.75,
        sm: 2
      },
      ml: {
        sm: -1
      },
      backgroundColor: 'primary.main',
      color: 'primary.contrastText',
      border: '1px solid',
      borderColor: 'primary.main',
      lineHeight: 1.3,
      fontSize: {
        xs: 14,
        sm: 16
      },
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'primary.dark',
        transitionProperty: 'background-color',
        transitionDuration: 'transition.duration.short',
        transitionTimingFunction: 'transition.easing.easeInOut'
      }
    },
    '& .hs_error_rollup': {
      display: 'none' // form has just one field so it's pointless to display errors summary for entire form
    },
    '& .hs-error-msgs': {
      listStyle: 'none',
      typography: theme.typography.bodySmallError,
      pl: 1,
      my: 0.5
    },
    '& .submitted-message': {
      typography: theme.typography.bodyLarge,
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }} data-sentry-element="Box" data-sentry-component="HubspotBlogForm" data-sentry-source-file="HubspotBlogForm.tsx" />;
};